import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { toast } from "sonner";
import Seo from "@/components/Seo";
import { useAuth } from "@/lib/auth";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

function formatErr(detail) {
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || "").join(" ");
  return "Something went wrong. Please try again.";
}

export default function AdminLogin() {
  const { user, login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back.");
      nav("/admin");
    } catch (err) {
      toast.error(formatErr(err.response?.data?.detail) || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-linen px-6">
      <Seo title="Admin Login — Let Go Wellness" description="Staff login." path="/admin/login" />
      <div className="w-full max-w-sm">
        <div className="mb-8 text-center">
          <div className="font-serif text-3xl text-ink">Let Go <span className="italic text-clay">Wellness</span></div>
          <p className="mt-2 font-sans text-sm text-muted-foreground">Staff sign-in</p>
        </div>
        <form onSubmit={submit} data-testid="admin-login-form" className="border border-border bg-white p-8">
          <Label className="font-sans text-xs text-ink-soft">Email</Label>
          <Input data-testid="admin-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1.5 mb-4 rounded-none border-border" />
          <Label className="font-sans text-xs text-ink-soft">Password</Label>
          <Input data-testid="admin-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="mt-1.5 rounded-none border-border" />
          <button type="submit" data-testid="admin-login-submit" disabled={loading} className="mt-6 w-full rounded-full bg-ink py-3.5 font-sans text-sm text-linen transition-colors hover:bg-ink/85 disabled:opacity-60">
            {loading ? "Signing in…" : "Sign in"}
          </button>
        </form>
      </div>
    </div>
  );
}
